import { ILoanVariablesDialogState } from 'store/reducers/loanVariablesDialog.reducer';

import { RootState } from '../store';

export const getLoanVariablesDialogState = (state: RootState): ILoanVariablesDialogState => state.loanVariablesDialog;
